/* =====================================================================
   MAISON LIGE – winkelwagenlade (namaak van de Kaching Cart-lade uit het bronthema).
   Zelfde DOM-klassen als Kaching, zodat de bestaande regels in lige.css (vertrouwensblok,
   verzendbalk, upsell "Pair It With", badges) 1-op-1 gelden. Stelt window.kachingCartApi
   beschikbaar (refreshCart / openCart / closeCart / getCartData / setCheckoutButtonClickHandler),
   dus lige.js werkt ongewijzigd. Alle data uit /cart.js en /products/<handle>.js.
   ===================================================================== */
(function () {
  'use strict';
  var cfg = {};
  try { cfg = JSON.parse(document.getElementById('lige-cart-config').textContent); } catch (e) {}
  function root() { var r = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; return r.slice(-1) === '/' ? r : r + '/'; }

  /* ---------- geld (zelfde opmaak als de rest van de winkel) ---------- */
  function money(cents) {
    cents = Number(cents) || 0;
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || cfg.currency;
    if (cur && cfg.currency && cur !== cfg.currency && window.Intl) {
      try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: cur }).format(cents / 100); } catch (e) {}
    }
    var f = cfg.money_format || '${{amount}}';
    function d(n, dec, th, sep) { var p = (n / 100).toFixed(dec).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th); return p[1] ? p[0] + sep + p[1] : p[0]; }
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount': return d(cents, 2, ',', '.');
        case 'amount_no_decimals': return d(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return d(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return d(cents, 0, '.', ',');
        case 'amount_with_space_separator': return d(cents, 2, ' ', ',');
        default: return d(cents, 2, ',', '.');
      }
    }).replace(/<[^>]+>/g, '');
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  var ICON = {
    close: '<svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true"><path d="M2 2l12 12M14 2L2 14" stroke="currentColor" stroke-width="1.6" fill="none" stroke-linecap="round"/></svg>',
    minus: '<svg width="10" height="10" viewBox="0 0 10 10" aria-hidden="true"><path d="M1 5h8" stroke="currentColor" stroke-width="1.4"/></svg>',
    plus: '<svg width="10" height="10" viewBox="0 0 10 10" aria-hidden="true"><path d="M1 5h8M5 1v8" stroke="currentColor" stroke-width="1.4"/></svg>',
    trash: '<svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18M8 6V4h8v2M6 6l1 14h10l1-14M10 11v6M14 11v6"/></svg>',
    tag: '<svg width="10" height="10" viewBox="0 0 24 24" aria-hidden="true" fill="currentColor"><path d="M21.4 11.6l-9-9A2 2 0 0 0 11 2H4a2 2 0 0 0-2 2v7c0 .55.22 1.05.59 1.42l9 9a2 2 0 0 0 2.82 0l7-7a2 2 0 0 0 0-2.82zM6.5 8A1.5 1.5 0 1 1 8 6.5 1.5 1.5 0 0 1 6.5 8z"/></svg>'
  };

  var el, inner, body, footer, cart = null, open = false, busy = false, checkoutHandler = null;
  var products = {};
  function productJson(handle) {
    if (products[handle]) return products[handle];
    products[handle] = fetch(root() + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).catch(function () { return null; });
    return products[handle];
  }

  function build() {
    if (el) return;
    el = document.createElement('div');
    el.className = 'kaching-cart kaching-cart__right-anchor lige-cd';
    el.setAttribute('aria-hidden', 'true');
    el.innerHTML = '<div class="kaching-cart__overlay" data-lige-cd-close></div>' +
      '<div class="kaching-cart__inner" role="dialog" aria-modal="true" aria-label="' + esc(cfg.t_title || 'Your Cart') + '">' +
      '<div class="kaching-cart__header kaching-cart__header--left"><p class="kaching-cart__heading"></p>' +
      '<button type="button" class="kaching-cart__close" aria-label="' + esc(cfg.t_close || 'Close cart') + '" data-lige-cd-close>' + ICON.close + '</button></div>' +
      '<div class="kaching-cart__contents"></div><div class="kaching-cart__footer"></div></div>';
    document.body.appendChild(el);
    inner = el.querySelector('.kaching-cart__inner');
    body = el.querySelector('.kaching-cart__contents');
    footer = el.querySelector('.kaching-cart__footer');
    el.addEventListener('click', onClick);
    el.addEventListener('change', onChange);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && open) closeCart(); });
  }

  function fetchCart() {
    return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { cart = c; return c; });
  }

  function render() {
    if (!el || !cart) return Promise.resolve();
    var handles = {};
    cart.items.forEach(function (i) { handles[i.handle] = true; });
    return Promise.all(Object.keys(handles).map(productJson)).then(function () { return Promise.all(Object.keys(handles).map(function (h) { return products[h]; })); }).then(function (list) {
      var byHandle = {}; list.forEach(function (p) { if (p) byHandle[p.handle] = p; });
      el.querySelector('.kaching-cart__heading').textContent = (cfg.t_title || 'Your Cart') + ' • ' + cart.item_count;
      if (!cart.items.length) {
        body.innerHTML = '<div class="kaching-cart__empty"><p class="kaching-cart__empty-text">' + esc(cfg.t_empty || 'Your cart is empty') + '</p>' +
          '<a class="kaching-cart__empty-button" href="' + esc(cfg.continue_url || root()) + '">' + esc(cfg.t_continue || 'Continue Shopping') + '</a></div>';
        footer.innerHTML = ''; footer.hidden = true;
        document.dispatchEvent(new CustomEvent('lige:cart-rendered'));
        return;
      }
      footer.hidden = false;
      var sumOld = 0, html = '';
      html += '<div class="kaching-cart__module"><div class="kaching-cart__announcement-bar">' + esc(cfg.t_shipping || 'You’ve unlocked free shipping!') + '</div></div>';
      html += '<div class="kaching-cart__module"><div class="kaching-cart__tiered-promotions-bar"><span></span></div></div>';
      html += '<div class="kaching-cart__module kaching-cart__module--items">';
      cart.items.forEach(function (it, idx) {
        var p = byHandle[it.handle], v = p && p.variants.filter(function (x) { return x.id === it.variant_id; })[0];
        var compare = v && v.compare_at_price > it.original_price ? v.compare_at_price : it.original_price;
        var old = compare * it.quantity, fin = it.final_line_price;
        sumOld += old;
        var save = old > fin ? Math.round((old - fin) / old * 100) : 0;
        var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '$1$2') + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=240' : '';
        var sel = '';
        if (p && !it.product_has_only_default_variant && p.variants.length > 1) {
          var oname = (p.options && p.options[0] && (p.options[0].name || p.options[0])) || '';
          sel = '<span class="kaching-cart-item__option-names">' + esc(oname) + ':</span>' +
            '<div class="kaching-cart-item__variant-selectors"><div class="kaching-variant-selectors-row"><div class="kaching-variant-selectors-row__selectors">' +
            '<select class="kaching-cart-selector" data-line="' + (idx + 1) + '" data-qty="' + it.quantity + '" aria-label="' + esc(oname) + '">' +
            p.variants.filter(function (x) { return x.available || x.id === it.variant_id; }).map(function (x) { return '<option value="' + x.id + '"' + (x.id === it.variant_id ? ' selected' : '') + '>' + esc(x.title) + '</option>'; }).join('') +
            '</select></div></div></div>';
        }
        html += '<div class="kaching-cart-item-container"><div class="kaching-cart-item" data-line="' + (idx + 1) + '">' +
          '<div class="kaching-cart-item__image-container"><a class="kaching-cart-item__link" href="' + esc(it.url) + '" tabindex="-1">' + (img ? '<img class="kaching-cart-item__image" src="' + esc(img) + '" alt="' + esc(it.product_title) + '" width="80" height="80" loading="lazy">' : '') + '</a></div>' +
          '<div class="kaching-cart-item__content"><div class="kaching-cart-item__content-left"><div class="kaching-cart-item__info">' +
          '<a class="kaching-cart-item__title" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + sel + '</div>' +
          '<div class="kaching-cart-item__quantity-controls">' +
          '<button type="button" class="kaching-cart-item__quantity-btn kaching-cart-item__quantity-btn--decrement" data-qty-step="-1" data-line="' + (idx + 1) + '" aria-label="' + esc(cfg.t_decrease || 'Decrease quantity') + '">' + ICON.minus + '</button>' +
          '<input class="kaching-cart-item__quantity-input" type="number" min="0" value="' + it.quantity + '" data-line="' + (idx + 1) + '" aria-label="' + esc(cfg.t_quantity || 'Quantity') + '">' +
          '<button type="button" class="kaching-cart-item__quantity-btn kaching-cart-item__quantity-btn--increment" data-qty-step="1" data-line="' + (idx + 1) + '" aria-label="' + esc(cfg.t_increase || 'Increase quantity') + '">' + ICON.plus + '</button>' +
          '</div></div>' +
          '<div class="kaching-cart-item__content-right"><div class="kaching-cart-item__price-info"><div class="kaching-cart-item__total">' +
          (old > fin ? '<s class="kaching-cart-item__total-old">' + money(old) + '</s>' : '') +
          '<span class="kaching-cart-item__total-final">' + (fin === 0 ? esc(cfg.t_free || 'FREE') : money(fin)) + '</span></div>' +
          (save ? '<div class="kaching-cart__badge"><div>' + ICON.tag + '</div><span>' + esc(cfg.t_save || 'You Save') + ' ' + save + '%</span></div>' : '') +
          '</div><button type="button" class="kaching-cart-item__remove-btn" data-remove-line="' + (idx + 1) + '" aria-label="' + esc((cfg.t_remove || 'Remove') + ' ' + it.product_title) + '">' + ICON.trash + '</button></div>' +
          '</div></div></div>';
      });
      html += '</div>';
      body.innerHTML = html;

      /* voet: kortingen (titel + totale besparing t.o.v. de doorgestreepte prijzen), subtotaal, afrekenen, betaalmethoden */
      var titles = {};
      (cart.cart_level_discount_applications || []).forEach(function (d) { titles[d.title] = true; });
      cart.items.forEach(function (i) { (i.discounts || []).forEach(function (d) { titles[d.title] = true; }); (i.line_level_discount_allocations || []).forEach(function (a) { if (a.discount_application) titles[a.discount_application.title] = true; }); });
      var saved = sumOld - cart.total_price, f = '';
      if (saved > 0) {
        f += '<div class="kaching-cart__cart-discounts"><div class="kaching-cart__cart-discounts-title">' + esc(cfg.t_discounts || 'Discounts') +
          Object.keys(titles).map(function (t) { return '<div class="kaching-cart__cart-discounts-badge">' + ICON.tag + '<span>' + esc(t) + '</span></div>'; }).join('') +
          '</div><div class="kaching-cart__cart-discounts-amount">-' + money(saved) + '</div></div>';
      }
      f += '<div class="kaching-cart__subtotal">' + esc(cfg.t_subtotal || 'Subtotal') + '<span>' + (sumOld > cart.total_price ? '<s class="kaching-cart__subtotal-original">' + money(sumOld) + '</s>' : '') + money(cart.total_price) + '</span></div>';
      f += '<button type="button" class="kaching-cart__checkout-button" data-lige-checkout><span class="kaching-cart__checkout-button-text"><span class="kaching-cart__checkout-button-label">' + esc(cfg.t_checkout || 'Checkout') + ' • ' + money(cart.total_price) + '</span></span></button>';
      var pay = document.getElementById('lige-cart-payment-icons');
      if (pay) f += '<div class="kaching-cart__payment-icons">' + pay.innerHTML + '</div>';
      footer.innerHTML = f;
      document.querySelectorAll('[data-lige-cart-count]').forEach(function (c) { c.textContent = cart.item_count; c.hidden = cart.item_count === 0; });
      document.dispatchEvent(new CustomEvent('lige:cart-rendered'));
    });
  }

  function refreshCart() { build(); return fetchCart().then(render); }
  function openCart() {
    build();
    return refreshCart().then(function () {
      open = true; el.classList.add('active'); el.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('kaching-cart--open'); document.body.classList.add('kaching-body__cart-open');
      var c = el.querySelector('.kaching-cart__close'); if (c) c.focus({ preventScroll: true });
    });
  }
  function closeCart() {
    if (!el) return; open = false; el.classList.remove('active'); el.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('kaching-cart--open'); document.body.classList.remove('kaching-body__cart-open');
  }
  function update(url, data) {
    if (busy) return Promise.resolve(); busy = true; el.classList.add('is-busy');
    return fetch(root() + url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(data) })
      .then(function (r) { return r.json(); })
      .then(function () { busy = false; return refreshCart(); })
      .catch(function () { busy = false; })
      .then(function () { el.classList.remove('is-busy'); document.dispatchEvent(new CustomEvent('cart:updated')); });
  }
  function onClick(e) {
    var t = e.target;
    if (t.closest('[data-lige-cd-close]')) { e.preventDefault(); closeCart(); return; }
    var step = t.closest('[data-qty-step]');
    if (step) { var line = Number(step.getAttribute('data-line')), it = cart.items[line - 1]; update('cart/change.js', { line: line, quantity: Math.max(0, it.quantity + Number(step.getAttribute('data-qty-step'))) }); return; }
    var rm = t.closest('[data-remove-line]');
    if (rm) { update('cart/change.js', { line: Number(rm.getAttribute('data-remove-line')), quantity: 0 }); return; }
    if (t.closest('[data-lige-checkout]')) {
      e.preventDefault();
      var go = true; if (checkoutHandler) { try { go = checkoutHandler() !== false; } catch (err) {} }
      if (go) window.location.href = root() + 'checkout';
    }
  }
  function onChange(e) {
    var t = e.target;
    if (t.matches('.kaching-cart-item__quantity-input')) { update('cart/change.js', { line: Number(t.getAttribute('data-line')), quantity: Math.max(0, parseInt(t.value, 10) || 0) }); return; }
    if (t.matches('.kaching-cart-selector')) {
      /* kleur wisselen: regel weghalen en de nieuwe variant met dezelfde hoeveelheid toevoegen */
      var line = Number(t.getAttribute('data-line')), qty = Number(t.getAttribute('data-qty')) || 1, id = Number(t.value);
      if (busy) return; busy = true;
      fetch(root() + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: line, quantity: 0 }) })
        .then(function () { return fetch(root() + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: qty }] }) }); })
        .then(function () { busy = false; return refreshCart(); })
        .catch(function () { busy = false; })
        .then(function () { document.dispatchEvent(new CustomEvent('cart:updated')); });
    }
  }

  window.kachingCartApi = {
    refreshCart: refreshCart,
    openCart: openCart,
    closeCart: closeCart,
    getCartData: function () { return cart; },
    setCheckoutButtonClickHandler: function (fn) { checkoutHandler = fn; }
  };
  /* openen via ?cart=open of #cart (bijv. na terugkeer van de checkout) */
  if (/[?&]cart=open\b/.test(location.search)) openCart();
})();
